(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation"]) return;
  try {
    


function cmPreviewNavigationInit() {
  document.querySelectorAll('.cm-preview-navigation .cm-preview-nav-details').forEach(details => {
    if (details.dataset.cmReady) return;
    details.dataset.cmReady = 'true';
    details.addEventListener('toggle', () => {
      if (details.open) document.querySelectorAll('.cm-preview-navigation .cm-preview-nav-details').forEach(other => { if (other !== details) other.open = false; });
    });
  });
}
cmPreviewNavigationInit();
document.addEventListener('shopify:section:load', cmPreviewNavigationInit);
document.addEventListener('click', event => {
  document.querySelectorAll('.cm-preview-navigation .cm-preview-nav-details[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.cm-preview-nav-details[open]').forEach(details => { details.open = false; details.querySelector('summary').focus(); });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
(() => {
  const attached = new WeakSet();
  const norm = value => (value || "").trim().toLowerCase().replace(/[?:*]/g, "").replace(/\s+/g, " ").trim();
  const values = nodes => [...new Set(Array.from(nodes, n => n.value.trim()))].sort();
  const same = (a, b) => a.length > 0 && a.length === b.length && a.every((v, i) => v === b[i]);
  function reconcile(form) {
    const replacements = new Set();
    const boxes = Array.from(form.querySelectorAll(".ymq-shopify-option-box"));
    for (const select of form.querySelectorAll(".single-option-selector")) {
      const wrapper = select.closest(".selector-wrapper");
      if (!wrapper) continue;
      const label = wrapper.querySelector("label");
      const title = label ? Array.from(label.childNodes).filter(n => n.nodeType === 3).map(n => n.textContent).join(" ") : "";
      const nativeValues = values(select.querySelectorAll("option"));
      const box = boxes.find(item => {
        if (norm(item.dataset.label) !== norm(title)) return false;
        const controls = item.querySelectorAll("input.ymq-shopify-option[type=radio], select.ymq-shopify-option option");
        return same(nativeValues, values(controls)) && item.getAttribute("hidden") === null && item.style.display !== "none";
      });
      if (box) {
        replacements.add(wrapper);
        const index = select.dataset.index?.replace("option", "");
        if (index) {
          const swatch = form.querySelector('.swatch[data-option-index="' + (Number(index) - 1) + '"]');
          if (swatch) replacements.add(swatch);
        }
      }
    }
    for (const node of form.querySelectorAll(".selector-wrapper, .swatch")) {
      node.toggleAttribute("data-cm-replaced", replacements.has(node));
    }
    const parents = new Set(boxes.map(box => box.parentElement));
    for (const parent of parents) {
      const children = Array.from(parent.children).filter(node => node.classList.contains("ymq-options-box"));
      const firstCustom = children.find(node => !node.classList.contains("ymq-shopify-option-box"));
      if (!firstCustom) continue;
      for (const box of children.filter(node => node.classList.contains("ymq-shopify-option-box"))) {
        if (Array.from(parent.children).indexOf(box) > Array.from(parent.children).indexOf(firstCustom)) {
          parent.insertBefore(box, firstCustom);
        }
      }
    }
  }
  function init() {
    document.querySelectorAll("body.template-product .ptContainer form.productForm").forEach(form => {
      if (attached.has(form)) return;
      attached.add(form);
      let queued = false;
      const observer = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          observer.disconnect();
          reconcile(form);
          observer.observe(form, {childList:true, subtree:true, attributes:true, attributeFilter:["class","style","hidden"]});
        });
      });
      reconcile(form);
      observer.observe(form, {childList:true, subtree:true, attributes:true, attributeFilter:["class","style","hidden"]});
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, {once:true});
  else init();
  document.addEventListener("shopify:section:load", init);
})();

(function () {
  function connectReviewHeadingCleanup() {
    var widget = document.getElementById('judgeme_product_reviews');
    if (!widget) return;
    function hideMediaHeading() {
      widget.querySelectorAll('h2,h3,h4,p,div,span').forEach(function (element) {
        if (element.textContent.trim() === 'Customer photos & videos' && !element.classList.contains('cm-hidden-media-heading')) {
          element.classList.add('cm-hidden-media-heading');
        }
      });
    }
    hideMediaHeading();
    new MutationObserver(hideMediaHeading).observe(widget, {childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',connectReviewHeadingCleanup);
  else connectReviewHeadingCleanup();
})();

  } catch(e) { console.error(e); }
})();
})();
